import { ViewFactory } from 'src/3rds/cube-react'
import { RestrictedScope } from '../Restricted.scopes'
import { RestrictedView } from './Restricted.view'

export function registerViews(rv = ViewFactory.register) {
    rv(RestrictedScope, RestrictedView)
}
